import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Alert, AlertTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { renderTextField } from './forms';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { login } from './auth/AuthService';
import { setSessionData, clearSessionData } from './redux/actions';
import { handleAlertOpen, handleAlertClose, handleProgressOpen, handleProgressClose } from './redux/actions/alertActions';

class LoginForm extends Component {
	constructor(props) {
		super(props);

        this.handleAlertOpen = this.props.handleAlertOpen.bind(this);
        this.handleProgressOpen = this.props.handleProgressOpen.bind(this);
        this.handleProgressClose = this.props.handleProgressClose.bind(this);
	}

	handleSubmit(credentials) {
		this.handleProgressOpen();
		login(credentials).then(loginAttempt => this.props.handleLoginAttempt(loginAttempt));
	}

	render() {
		let loginAlert = this.props.loginError ?
			(<Alert className="nf-alert" severity="warning">
				<AlertTitle>We couldn’t log you in.</AlertTitle>
				{this.props.loginError}
			</Alert>)
		: null;

		return (
			<form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))}>
				<h1 className="auth-title">Sign in</h1>
				<p className="auth-sub">Play from where you left off.</p>
				{ loginAlert }
        		<div className="login-form-row">
					<Field name="email" component={renderTextField} label="Email"/>
				</div>
    			<div className="login-form-row-extra">
					<Field name="password" component={renderTextField} label="Password" type="password"/>
				</div>
				<div className="login-form-row-extra">
					<Button type="submit" variant="contained" className="auth-submit">Login</Button>
                </div>

				<div className="auth-links">
					<p className="auth-hint">Don't have an account? <Link className="auth-link" to="/register">Create an account</Link>.</p>
					<p className="auth-hint"><Link className="auth-link" to="/requestPasswordReset">Forgot your password?</Link></p>
				</div>
			</form>
		);
	}
}

// Decorate the form component
LoginForm = reduxForm({
	form: 'loginForm' // a unique name for this form
})(LoginForm);

const mapStateToProps = state => {
	return {
		sessionStatus: state.session.sessionStatus,
		username: state.session.username,
		loginError: state.session.loginError
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
		handleLoginAttempt: (loginAttempt) => {
			dispatch(handleProgressClose());
			if (loginAttempt.error) {
				dispatch(clearSessionData(loginAttempt.error));
			}
			else {
				dispatch(setSessionData(loginAttempt.account));
				// Dismiss any lingering "session expired" notice on successful re-login.
				dispatch(handleAlertClose());
			}
		},
		handleAlertOpen: (alert) => {
            dispatch(handleAlertOpen(alert));
		},
		handleProgressOpen: () => {
            dispatch(handleProgressOpen());
		},
        handleProgressClose: () => {
            dispatch(handleProgressClose());
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
